export type OperationsDeepLink = {
  /** Seeds the Machine Name filter. */
  machine: string | null;
  /** Row to scroll to and glow, for when the filter still leaves more than one. */
  plantId: number | null;
};

export const OPERATIONS_DEEP_LINK_PARAMS = ["machine", "plantId"];

export const OPERATIONS_PATH = "/operations";

const positiveInt = (raw: string | null): number | null => {
  const value = Number(raw);
  return raw && Number.isInteger(value) && value > 0 ? value : null;
};

/** Reads what a dashboard card asked the Operations page to show. */
export const readOperationsDeepLink = (params: URLSearchParams): OperationsDeepLink => ({
  machine: params.get("machine") || null,
  plantId: positiveInt(params.get("plantId")),
});

/**
 * Writes what `readOperationsDeepLink` reads. Both live here so the param names have one owner and
 * a rename cannot leave a link pointing at something the page no longer looks for.
 */
export const operationsLink = (link: Partial<OperationsDeepLink>): string => {
  const params = new URLSearchParams();

  if (link.machine) params.set("machine", link.machine);
  if (link.plantId) params.set("plantId", String(link.plantId));

  return params.size === 0 ? OPERATIONS_PATH : `${OPERATIONS_PATH}?${params}`;
};

/** Whether a link asked for anything, so a plain visit is left alone. */
export const hasOperationsDeepLink = (link: OperationsDeepLink): boolean =>
  link.machine !== null || link.plantId !== null;
